import { del, get, post, patch } from "../api_helper"
import { JOBS_REFERRALS_ROUTES } from "../url_helper"

// get job Referrals
export const getReferrals = queryParams =>
  get(`${JOBS_REFERRALS_ROUTES}${queryParams ? queryParams : ""}`)
